import React from 'react'
import {Link} from 'react-router-dom';
import { useContext } from 'react';
import CartContext from '../context/CartContext';
const Navbar = () => {
    const {cart,setCart} = useContext(CartContext);
  return (
    <div>
        <section className="topbar">
    <div className="logo">
        <img src="../img/logoxxx.PNG" alt=""/>
    </div>
    <nav>
        <ul>
            <li>
                <Link to="/">Home</Link>
            </li>
            <li>
                <Link to="products">Products</Link>
            </li>
            <li>
                <Link to="test">Product</Link>
            </li>
            <li>
                <Link to="card">Cart ({cart.length})</Link>
            </li>
        </ul>
    </nav>
</section>
    </div>
  )
}

export default Navbar
